import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { RoutesPaths } from "../../Router/constant";
import AuthService from "../../services/auth.service";
import "./style.css";

export default function Landing() {
  const navigate = useNavigate();
  const [queryParameters] = useSearchParams();
  const [inviter, setInviter] = useState(null);

  useEffect(() => {
    const inviteToken = queryParameters.get("pro_invite");

    if (!inviteToken) return;
    const loadInviteDetails = async () => {
      try {
        const response = await AuthService.getInviteUserDetails(inviteToken);
        if (response?.status === false) {
          navigate(RoutesPaths.ERROR_PAGE, { replace: true });
          return;
        }
        sessionStorage.setItem(
          "publicChatInviter",
          JSON.stringify(response?.data?.inviter || null)
        );
        setInviter(response?.data?.inviter);
      } catch (error) {
        navigate(RoutesPaths.ERROR_PAGE, { replace: true });
      }
    };

    loadInviteDetails();
  }, [navigate, queryParameters]);

  const handleLandingClick = () => {
    if (inviter) {
      navigate(RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT?.replace(":id", inviter?.inviter_id));
    } else {
      navigate(RoutesPaths.MESSAGE_DETAIL_PUBLIC);
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12 mt-4">
            <div className="Innercontainer">
              <img onClick={handleLandingClick} src="/assets/img/landing_banner.png" alt="" srcSet="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
